module.exports = __webpack_public_path__ + "img/neutralnetworks_blanco.bba4df65.svg";